import { Component } from '@theme/component';

class StackingComponent extends Component {
  /** @type {number} */
  currentIndex = 1;

  /** @type {number} */
  totalBlocks = 0;

  connectedCallback() {
    super.connectedCallback();
    const blocks = this.querySelectorAll('.stacking-product');
    const markers = this.querySelectorAll('.stacking__marker');
    this.totalBlocks = blocks.length;

    // Assign data-index dynamically since theme blocks don't know their index
    // This also fixes the displayed index text, which Liquid can't compute reliably
    // when blocks are nested inside another block (e.g. _collection-stacking inside a section)
    blocks.forEach((block, i) => {
      const index = i + 1;
      block.setAttribute('data-index', String(index));

      const indexEl = block.querySelector('.stacking-product__index');
      if (indexEl) indexEl.textContent = String(index);
    });

    // Reassign data-index on markers too — same ordering as blocks
    markers.forEach((marker, i) => {
      const index = i + 1;
      marker.setAttribute('data-index', String(index));
      marker.textContent = `${index}.`;
    });

    // Refresh initial active state
    this.#activateBlock(this.currentIndex);
  }

  /**
   * Select a block by index
   * @param {Event} event
   */
  selectBlock(event) {
    const target = /** @type {HTMLElement} */ (event.target)?.closest('[data-index]');
    if (!target) return;

    const index = /** @type {HTMLElement} */ (target).dataset.index;
    if (!index) return;

    this.#activateBlock(parseInt(index, 10));
  }

  /**
   * Go to previous block
   */
  prevBlock() {
    let newIndex = this.currentIndex - 1;
    if (newIndex < 1) newIndex = this.totalBlocks;
    this.#activateBlock(newIndex);
  }

  /**
   * Go to next block
   */
  nextBlock() {
    let newIndex = this.currentIndex + 1;
    if (newIndex > this.totalBlocks) newIndex = 1;
    this.#activateBlock(newIndex);
  }

  /**
   * Activate a block by index
   * @param {number} index
   */
  #activateBlock(index) {
    this.currentIndex = index;
    const indexStr = String(index);

    // Update markers
    this.querySelectorAll('.stacking__marker').forEach((marker) => {
      /** @type {HTMLElement} */ (marker).classList.toggle('is-active', /** @type {HTMLElement} */(marker).dataset.index === indexStr);
    });

    // Update blocks
    this.querySelectorAll('.stacking-product').forEach((block) => {
      /** @type {HTMLElement} */ (block).classList.toggle('is-active', /** @type {HTMLElement} */(block).dataset.index === indexStr);
    });

    // Update pagination indicator
    this.#updatePaginationIndicator();
  }

  /**
   * Update the pagination indicator
   */
  #updatePaginationIndicator() {
    const indicator = /** @type {HTMLElement | undefined} */ (this.refs.currentIndex);
    if (indicator) {
      indicator.textContent = String(this.currentIndex);
    }
  }
}

customElements.define('stacking-component', StackingComponent);
